import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./context/AuthContext";
import { AlertProvider } from "./context/AlertContext";
import { AppThemeProvider } from "./context/ThemeContext";

const root=ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <AppThemeProvider>
      <AlertProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </AlertProvider>
    </AppThemeProvider>
  </React.StrictMode>
);

reportWebVitals();